// extracted by mini-css-extract-plugin
export default {"order-body":"order-body_order-body__kei5S","fixed-header":"order-body_fixed-header__pmzgy"};